// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1fgGZ","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__1JOvn","gfeWrapper":"CalendarEvent_gfeWrapper__1d70M"};